Object.defineProperty(exports, '__esModule', {
  value: true
});
var lab = require('@material-ui/lab');
var core = require('@material-ui/core');
var Cancel = require('@material-ui/icons/Cancel');
var CustomChip = require('@ds-developer/custom-chip');
var React = require('react');
var Search = require('@material-ui/icons/Search');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var Cancel__default = /*#__PURE__*/_interopDefaultLegacy(Cancel);
var CustomChip__default = /*#__PURE__*/_interopDefaultLegacy(CustomChip);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Search__default = /*#__PURE__*/_interopDefaultLegacy(Search);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }
  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }
  return r;
}
var Box = core.Box;
var useStyles = core.makeStyles(function (theme) {
  return {
    root: {
      width: "100%"
    },
    container: {
      padding: theme.spacing(2)
    },
    cardContent: {
      padding: 0,
      "&:last-child": {
        paddingBottom: 0
      }
    },
    title: {
      lineHeight: "1.6",
      color: "#000",
      fontWeight: 400
    },
    chip: {
      "& .MuiButton-label": {
        textTransform: "none"
      },
      border: "none"
    }
  };
});
var TestCentres = function TestCentres(_a) {
  var title = _a.title,
    data = _a.data,
    testCentres = _a.testCentres,
    setValue = _a.setValue;
  var classes = useStyles();
  var _b = React.useState(""),
    inputValue = _b[0],
    setInputValue = _b[1];
  var handleSelect = function handleSelect(_event, value) {
    if (value) {
      setValue(__spreadArrays(testCentres, [value]));
      setInputValue("");
    }
  };
  var handleInputChange = function handleInputChange(_event, newInputValue) {
    setInputValue(newInputValue);
  };
  var handleDelete = function handleDelete(itemToDelete) {
    return function () {
      var items = testCentres.filter(function (item) {
        return item.id !== itemToDelete.id;
      });
      setValue(items);
    };
  };
  return React__default['default'].createElement(core.Card, {
    "data-test": "test-centres"
  }, React__default['default'].createElement(core.CardHeader, {
    titleTypographyProps: {
      component: "h3",
      variant: "h3"
    },
    title: "My test centres",
    "data-test": "my-test-centres-card-title"
  }), React__default['default'].createElement(core.Divider, null), React__default['default'].createElement(core.CardContent, {
    className: classes.cardContent
  }, React__default['default'].createElement(core.Grid, {
    container: true,
    className: classes.container
  }, React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12
  }, React__default['default'].createElement(core.Typography, {
    variant: "h3",
    className: classes.title
  }, title)), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    md: 8
  }, React__default['default'].createElement(Box, {
    mt: 2
  }, React__default['default'].createElement(lab.Autocomplete, {
    fullWidth: true,
    onChange: handleSelect,
    options: data,
    value: null,
    inputValue: inputValue,
    onInputChange: handleInputChange,
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    getOptionDisabled: function getOptionDisabled(option) {
      return testCentres.some(function (el) {
        return el.id === option.id;
      });
    },
    renderInput: function renderInput(params) {
      return React__default['default'].createElement(core.TextField, _assign({}, params, {
        name: "testCentre",
        label: "Search for a test centre",
        variant: "outlined",
        InputProps: _assign(_assign({}, params.InputProps), {
          endAdornment: null,
          startAdornment: React__default['default'].createElement(Search__default['default'], null)
        })
      }));
    }
  }))), React__default['default'].createElement(core.Grid, {
    item: true,
    xs: 12,
    "data-test": "my-test-centres-selected-items"
  }, React__default['default'].createElement(Box, {
    mt: 2
  }, testCentres.map(function (item) {
    return React__default['default'].createElement(CustomChip__default['default'], {
      key: item.id,
      label: item.name,
      backgroundColor: "#ECEFF1",
      hoverBackgroundColor: "#ECEFF1",
      endIcon: React__default['default'].createElement(Cancel__default['default'], {
        htmlColor: "#546E7A"
      }),
      onClick: handleDelete(item),
      className: classes.chip
    });
  }))))));
};
exports.default = TestCentres;